import { Container, Row } from 'react-bootstrap';
import { FundsDistributionForm } from 'core/cuenta/components/FundsDistributionForm/FundsDistributionForm';
import { PageTitle } from 'shared/components/Fonts';

export const FundsDistributionPage = () => {
  return (
    <Container fluid>
      <Row className="mb-3">
        <PageTitle>Distribución de Fondos</PageTitle>
      </Row>
      <FundsDistributionForm />
    </Container>
  );
};
